
<style>

    .center {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height:200px;
        width: 600px;
    }
    .centerdiv {
        margin-left: auto;
        margin-right: auto;
        display: block;
        text-align: center;
        background-color: black;
    }
    .backgroundDiv{
      text-align: center;
    opacity: 0.9;
    }
    </style>
     
     
     <nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
      <!-- Left navbar links -->
     
  
      <!-- Right navbar links -->
      <ul class="navbar-nav lg-auto"  >
       
          <li class="nav-item" *ngIf="ocultarCarrito == false" >
            <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
              <i class="fas fa-bars" style="font-size: 48px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
            </a>
          </li>
   
        
  
        <!-- Navbar Search -->
        <li class="nav-item">
          <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
            <i class="fas fa-search"style="font-size: 42px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
          </a>
          <div class="navbar-search-block" >
            <form class="form-inline"  [formGroup]="formBuscar" >
              <div class="input-group input-group-sm" >
                <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: x-large;height: 48px;border: 2px solid #424949; color: rgb(245, 17, 17);font-weight: bold;background-color: rgb(241, 241, 247);height: 52px;" formControlName="txtBuscar" >
                <div class="input-group-append">
                  <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()" style="border: 2px solid #424949;"  >
                    <i class="fas fa-search" style="font-size: 40px;"></i>
                  </button>
                  <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                    <i class="fas fa-times" style="font-size: 40px;"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li>
  
      
  
      </ul>
      
     
      
      <ul    class="navbar-nav ml-auto">
        <li  class="nav-item" >
      
          <div >
            <img src="./assets/dist/img/titulo_andrea.png"  width="130" height="35"  />
           </div>
     
        
        </li>  
  
      </ul>
  
      <ul    class="navbar-nav ml-auto">
  
        
  
  
  
        <li  class="nav-item dropdown" *ngIf="tieneSession == true" >
  
          <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
       
  
              <img src="./assets/dist/img/user.png"  width="auto" height="52" style="margin-top: -10px;margin-right: -12px;"  />
  
       
            
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <a href="#" class="dropdown-item">
              <!-- Message Start -->
              <div class="media">
              
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                    {{nombreCuenta}}
                    <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                  </h3>
                  
                </div>
              </div>
              <!-- Message End -->
            </a>
            <div class="dropdown-divider"></div>
            <a  class="dropdown-item" (click)="logout()">
              <!-- Message Start -->
              <div class="media">
               
                <div class="media-body">
                  <h3 class="dropdown-item-title">
                  Cerrar sesión
                    <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                  </h3>
                  
                </div>
              </div>
              <!-- Message End -->
            </a>
           
           
            
          </div>
  
        </li>
  
        <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;">
          <a href="#/carrito">
          <img src="./assets/dist/img/carro.png"  width="auto" height="52"   />
          </a>
        </li>
  
  
    
  
          <!-- <a  href="#/carrito">
            <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
          
          </a> -->
        
      
  
  
    <!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
    {{countpedido}}   
     
  </a> -->
  
  
  
  
       
  
  
       
  
  
      </ul>
     
  
    
  
  
  
  
    </nav>
  
  
  <app-sidebar-ecomerce></app-sidebar-ecomerce>
  
  
  
   
  <br>
  
  
  
    <div class="content-wrapper">
  
  
      <div class="content">
        <div class="container">
          <div class="row">
          
  
  
          
  
          </div>
  
          <div class="card card-success">
        
            <div class="col-sm-12">
             <video width="98%" height="98%" 
             controls 
             autoplay
             loop
             onloadedmetadata="this.muted=true"
             >
              <source src="./assets/dist/img/andreabanner.mp4" type="video/mp4">
             </video>
            </div>
            </div>
  
  
            <div class="card card-success">
        
            <div *ngIf="modoBusqueda== false">
  
              <div class="card-body">
                <div class="row">
                 
                  <div class="col-12 col-sm-12 col-md-12 align-items-stretch"  >
     

                    <strong  style="text-align: center;">  Política de Privacidad </strong><br>
                   
                   
Esta Política de Privacidad describe cómo se recopila, utiliza y comparte tu información personal cuando visitas o realizas una compra en www.andreagt.com.<br>

<strong>QUÉ INFORMACIÓN PERSONAL RECOPILAMOS</strong><br>

Cuando visitas el Sitio, recopilamos automáticamente cierta información sobre tu dispositivo, incluida información sobre tu navegador web, dirección IP, zona horaria.

Además, a medida que navegas por el Sitio, recopilamos información sobre las páginas web individuales o los productos que ves, qué sitios web o términos de búsqueda te remiten al Sitio, e información sobre cómo interactúas con el Sitio. Nos referimos a esta información recopilada automáticamente como Información del Dispositivo.

Recopilamos información del dispositivo utilizando las siguientes tecnologías:

IP PUBLICA: Información de servicio de internet que se tiene contradado en el dispositivo.

Además, cuando efectúas una compra o intentas realizar una compra a través del Sitio, recopilamos cierta información tuya, como tu nombre, dirección de facturación, dirección de envío, información de pago, incluidos números de tarjetas de crédito (VISA, CREDOMATIC),número de teléfono. Esto se denomina Información del Pedido.

Al referirnos a Información Personal en esta Política de Privacidad, estamos hablando tanto de la Información del Dispositivo como de la Información del Pedido.<br>

<strong>CÓMO USAMOS TU INFORMACIÓN PERSONAL</strong><br>

Utilizamos la Información de Pedido que recopilamos por lo general para cumplir con los pedidos realizados a través del Sitio (incluido el procesamiento de tu información de pago, la organización del envío y el envío de facturas y/o confirmaciones de pedidos).

Además, usamos esta Información del Pedido para: comunicarnos contigo, examinar nuestros pedidos para detectar posibles riesgos o fraudes, para (en línea con las preferencias que has compartido con nosotros) ofrecerte información o publicidad relacionada con nuestros productos o servicios.

Utilizamos la Información del Dispositivo que recopilamos para ayudarnos a detectar posibles riesgos y fraudes (en particular, tu dirección IP) y, en general, para mejorar y optimizar nuestro sitio.<br>

<strong>COMPARTIENDO TU INFORMACIÓN PERSONAL</strong><br>

Compartimos tu Información Personal con terceros para ayudarnos a utilizarla como se describió anteriormente.

También empleamos Google Analytics para ayudarnos a comprender cómo nuestros clientes usan www.andreagt.com. Cómo usa Google tu Información Personal..

Finalmente, también podemos compartir tu Información Personal para cumplir con las leyes y regulaciones aplicables, para responder a una citación, una orden de registro u otras solicitudes legales de información que recibimos, o para proteger nuestros derechos.<br>

<strong>PUBLICIDAD DE COMPORTAMIENTO</strong><br>


Utilizamos tu Información Personal para proporcionarte anuncios específicos o comunicaciones de marketing que creemos que pueden ser de tu interés.

Redes Sociales tales como:

Facebook
Twitter
<br>
<strong>TUS DERECHOS</strong><br>


Si eres un residente guatemalteco, tienes derecho a acceder a la información de tus pedidos, asi mismo vouchers pagos y obtener estado de tus pedidos para darle seguimiento.

RETENCIÓN DE DATOS

Cuando realices un pedido a través del Sitio, mantendremos tu Información de Pedido para nuestros registros a menos que y hasta que nos solicites eliminar esta información.<br>

<strong>MENORES</strong><br>

El Sitio no está destinado a personas menores de 18 años.

CAMBIOS Podemos actualizar esta política de privacidad de vez en cuando para reflejar, por ejemplo, cambios en nuestras prácticas o por otras razones operativas, legales o reglamentarias.

Si tiene preguntas y/o necesitas más información, no dudes en ponerte en contacto con nosotros a través del correo: andreagtfc024&#64;gmail.com.






             

                
  
                </div>
  
          
  
                  
                      <br>
  
                      
                </div>  
              </div>
            </div>
  
  
     
  
  
            <div *ngIf="modoBusqueda== true ">
  
              <div class="card-body">
                <div class="row">
  
              <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos of productosdto; let i=index" >
                   
                      
              
                <div class="row"  (click)="OnSelectProducto(datos.idProducto)">
  
               
                  <div class="text-center">
                   
                    <img class="img-fluid"
                         src={{urlServerUploadArticulos$}}{{datos.imagen}}{{tipoMedia2$}}
                         alt="User profile picture" style="height: 110%;width: 110%;">
                  </div>
                  
  
  
                  <div class="col-8">
  
                    <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                    <label class="text-muted text-sm">{{datos.descripcion}}</label>
                    <p class="text-muted text-sm"><b>Precio: </b> {{datos.precio | currency: 'Q'}}</p>
                   
                  </div>
                  <div class="col-8" >
                  
                
                 
                 </div>
                  
                  
               
                </div>
               
                  
            
              
        
            </div>
            </div>
            </div>
            </div>
  
  
            </div>
         
        
       
  
   
        </div>
        <div class="content">
          <div class="container">
            <div class="row">
  
              <div class="card card-success">
                <div class="card-body">

                   
                  
                    <div class="col-12 col-sm-12" >
  
                      



              <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
            </div>
         
        </div>
      </div>
    </div>
          </div>
        </div>
      </div>
  
         
     
     
    </div>
  
  
  
  <app-footer-ecomerce ></app-footer-ecomerce>
  
  